const mixinGroupData = {
  data() {
    return {
      rowspanInfo: {},
      rowSpanPagination: {},
      numberColumnIndex: 2,
    };
  },
  methods: {
    preprocessDataPagination(data, keyToValidate, indexSpanPagination) {
      let currentGroup = null;
      let currentSpan = 0;
      let startIndex = 0;

      this[indexSpanPagination] = {};

      data.forEach((row, index) => {
        const groupKey = keyToValidate.reduce(
          (acc, key, index) => (index === 0 ? row[key] : `${acc}-${row[key]}`),
          ''
        );

        if (groupKey !== currentGroup) {
          if (currentGroup !== null)
            this[indexSpanPagination][startIndex] = currentSpan;

          currentGroup = groupKey;
          currentSpan = 1;
          startIndex = index;
        } else {
          currentSpan++;
        }
      });

      if (currentGroup !== null)
        this[indexSpanPagination][startIndex] = currentSpan;

      return data;
    },
    preprocessData(data, keyToValidate, tableSpanInfoNumber = 1) {
      let currentGroup = null;
      let currentSpan = 0;
      let startIndex = 0;

      if (tableSpanInfoNumber === 1) this.rowspanInfo = {};
      else this.rowspanInfo2 = {};

      data.forEach((row, index) => {
        const groupKey = keyToValidate.reduce(
          (acc, key, index) => (index === 0 ? row[key] : `${acc}-${row[key]}`),
          ''
        );

        if (groupKey !== currentGroup) {
          if (currentGroup !== null) {
            if (tableSpanInfoNumber === 1)
              this.rowspanInfo[startIndex] = currentSpan;
            else this.rowspanInfo2[startIndex] = currentSpan;
          }
          currentGroup = groupKey;
          currentSpan = 1;
          startIndex = index;
        } else {
          currentSpan++;
        }
      });

      if (currentGroup !== null) {
        if (tableSpanInfoNumber === 1)
          this.rowspanInfo[startIndex] = currentSpan;
        else this.rowspanInfo2[startIndex] = currentSpan;
      }

      return data;
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      try {
        this.calculateSpanPagination;
      } catch (error) {
        //
      }

      if (columnIndex <= this.numberColumnIndex) {
        if (this.rowSpanPagination[rowIndex]) {
          const span = Math.min(
            this.rowSpanPagination[rowIndex],
            this.pagination.perPage - rowIndex
          );

          return {
            rowspan: span,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
};

export default mixinGroupData;
